
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import globalThis_1 from './global-this.js';
import shared$1 from './shared.js';
import hasOwnProperty_1 from './has-own-property.js';
import uid$1 from './uid.js';
import symbolConstructorDetection from './symbol-constructor-detection.js';
import useSymbolAsUid from './use-symbol-as-uid.js';

var globalThis = globalThis_1;
var shared = shared$1;
var hasOwn = hasOwnProperty_1;
var uid = uid$1;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

export { wellKnownSymbol as default };
//# sourceMappingURL=well-known-symbol.js.map
